import { IEmotionCharacterCount } from 'motw_core/DTOs/emotioncharactercount';
import * as React from 'react';
import { Emotions } from 'source/app/domain/Emotions/Emotions';
import { StyleClass } from '../../../../../../Shared/Styles/CSS';

export function DisplayEmotionCharacterCounts({
	characterCounts
}: {
	characterCounts?: IEmotionCharacterCount[];
}) {
	if (characterCounts === undefined || characterCounts.length === 0) {
		return null;
	}

	return (
		<span>
			{characterCounts.map((cc, index) => (
				<DisplayCharacterCount characterCount={cc} key={index} />
			))}
		</span>
	);
}

function DisplayCharacterCount({
	characterCount
}: {
	characterCount: IEmotionCharacterCount;
}) {
	const emotion = Emotions.GetFromCharacter(characterCount.result_value);

	const styleClass = StyleClass(
		`dwkc_characterCount_${characterCount.result_value}`,
		{
			color: emotion.hexColor,
			padding: '4px',
			borderRadius: '4px',
			fontWeight: 'bold',
			marginLeft: '5px'
		}
	);

	const tooltip = `${characterCount.result_count}x ${emotion.tooltip}`;
	const textToDisplay = `${characterCount.result_count}${emotion.character}`;

	return (
		<span className={styleClass} data-tip={tooltip}>
			{textToDisplay}
		</span>
	);
}
